var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container px-2 pt-3"},[_c('Stepper',{attrs:{"stepperSteps":_vm.stepperSteps,"showNavigation":false},on:{"completed-step":_vm.completeStep,"active-step":_vm.isStepActive,"closeModal":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }